/**
 * Intl.DisplayNames defaults several options if they aren't provided, namely `style` which defaults to long.
 * If for some reason we disagree with what the default should be, we set it here. If someone explicitly requests
 * style="long"|"narrow" we never override that choice.
 */
export const optionsOverrides = {
    HK: {
        region: {
            style: "short",
        },
    },
    MO: {
        region: {
            style: "short",
        },
    },
};
